











































import { Component, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'

@Component
export default class ViewInicio extends Vue {
  login() {
    Auth.login('/')
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(';')

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie

      if (name !== 'postLoginUrl') {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
      }
    }
  }

  mounted() {
    this.deleteAllCookies()
    localStorage.clear()
  }
}
